import { useQuery } from '@apollo/client'
import { useMemo, useState } from 'react'
import { keyBy } from 'lodash'
import { GET_MCAT_SPECIFIC_GAME_ANALYTICS_LEVEL_PERFORMANCE } from 'queries/gamesStats'
import {
  findMCATSpecificGameAnalyticsLevelPerformance,
  findMCATSpecificGameAnalyticsLevelPerformanceVariables,
} from '__generatedTypes__/findMCATSpecificGameAnalyticsLevelPerformance'

const LEVELS_COUNT = 10

export type ChartDataVariables = findMCATSpecificGameAnalyticsLevelPerformanceVariables

export const useChartData = (chartDataVariables: ChartDataVariables) => {
  const [isInitiallyLoaded, setIsInitiallyLoaded] = useState(false)

  const { data, loading } = useQuery<findMCATSpecificGameAnalyticsLevelPerformance, ChartDataVariables>(
    GET_MCAT_SPECIFIC_GAME_ANALYTICS_LEVEL_PERFORMANCE,
    {
      variables: {
        ...chartDataVariables,
      },
      fetchPolicy: 'cache-and-network',
      onCompleted: () => {
        setIsInitiallyLoaded(true)
      },
    }
  )

  const chartData = useMemo(() => {
    const availableLevelAnalytics = keyBy(data?.findMCATSpecificGameAnalyticsLevelPerformance, 'level')

    return new Array(LEVELS_COUNT).fill(0).map((_, index) => {
      const level = index + 1

      const levelAnalytics = availableLevelAnalytics[level]

      if (!levelAnalytics) {
        return {
          xAxisValue: level,
          yAxisValue: 0,
          correct: 0,
          incorrect: 0,
        }
      }

      return {
        xAxisValue: levelAnalytics.level,
        yAxisValue: levelAnalytics.correctAnsweredCount + levelAnalytics.incorrectAnsweredCount,
        correct: levelAnalytics.correctAnsweredCount,
        incorrect: levelAnalytics.incorrectAnsweredCount,
      }
    })
  }, [data])

  return {
    isInitiallyLoaded,
    chartData,
    loading,
  }
}
